import React from 'react';
import Navbar from '../components/Navbar';
import ProjectsHero from '../components/ProjectsHero';
import Work from '../components/Work';
import WorkCardData from '../components/WorkCardData';

const Project = () => {
  return (
    <div className="projects-page">
      <Navbar />
      <ProjectsHero projectCount={WorkCardData.length} />
      <Work />
    </div>
  );
};

export default Project;
